var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7807 11.7234L19.6805 2.82343C19.8865 2.61759 20 2.3428 20 2.04981C20 1.75681 19.8865 1.48202 19.6805 1.27618L19.0252 0.62076C18.5983 0.194274 17.9043 0.194274 17.478 0.62076L10.0045 8.09427L2.52269 0.612467C2.31668 0.406622 2.04206 0.292968 1.74922 0.292968C1.45606 0.292968 1.18144 0.406622 0.975269 0.612467L0.320175 1.26789C0.114168 1.47389 0.000677045 1.74852 0.000677032 2.04151C0.00067702 2.33451 0.114168 2.60929 0.320175 2.81514L9.22809 11.7234C9.43475 11.9297 9.71068 12.043 10.004 12.0424C10.2985 12.043 10.5742 11.9297 10.7807 11.7234Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow_bottom.b337254c76947b60571c5da829718d94.svg";
export { ForwardRef as ReactComponent };